
export default {
  name: 'BaseProfileStreamUserMenu',
  props: {
    stream: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isCopyId: false,
      isShowMenu: false,
    }
  },
  computed: {
    isAdmin() {
      return !!this.$auth?.user?.roles?.some((role) =>
        ['ADMIN', 'MODERATOR'].includes(role)
      )
    },
    isAllowShowMenu() {
      if (!this.$auth?.loggedIn) {
        return false
      } else {
        return (
          this.$auth.user.roles.find((role) => role === 'ADMIN') ||
          this.$auth.user.roles.find((role) => role === 'MODERATOR')
        )
      }
    },
  },
  methods: {
    async copyId(id) {
      if (typeof navigator.clipboard === 'undefined') {
        const textArea = document.createElement('textarea')
        textArea.value = id
        textArea.style.position = 'fixed'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        try {
          document.execCommand('copy')
          this.isCopyId = true
        } catch (err) {
          this.isCopyId = false
        }
        document.body.removeChild(textArea)
        return
      }
      await navigator.clipboard.writeText(id).then(() => {
        this.isCopyId = true
      })
      setTimeout(() => {
        this.closeMenu()
        this.isCopyId = false
      }, 500)
    },
    closeMenu() {
      this.isShowMenu = false
    },
  },
}
